import { useEffect, useState } from "react";

const readTheme = () => document.documentElement.dataset.theme || "meadow";

// The app's theme (data-theme on <html>), kept up to date when Settings changes it.
// For chrome that should follow the app even inside a note with its own theme.
export default function useAppTheme() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(readTheme()));
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => observer.disconnect();
  }, []);

  return theme;
}
